import React from 'react';
import BasicCard from '../../pages/BasicCard';
import peter from "../Dashboard/images/Frame 385.png"
import Button from "react-bootstrap/Button";




function MyPlanForm() {


    return (


        <div className='container '>

            <div className='col-lg-12 greybg '>
                <div className='row '>

                    <h5>MY PLAN </h5><br />

                    <div className="col-4 ">

                        <span className="">Name</span>
                        <p className=" bluefont fs-5 fw-bold">Venkat</p>

                        <span className="">Position</span>
                        <p className="bluefont fs-5 fw-bold">Line manager</p>

                    </div>


                    <div className="col-4 ">


                        <span className="">Employee ID</span>
                        <p className="fs-5 bluefont fw-bold">os004</p>

                        <span className="">Grade</span>
                        <p className=" bluefont fs-5 fw-bold">Grade-'A'</p>

                    </div>

                    <div className="col-lg-4 ">


                        <img className='float-end mr-5 mt-5' src={peter} width="110" lt="" />

                    </div>
                </div>

            </div>

            <div className='col-lg-12 mt-5'>
                <div className='row'>

                    <div class="col-lg-5">
                        <label>Current Role</label><br />
                        <input
                            type="text"
                            className='form-select form-control'

                        ></input>
                    </div>
                    <div class="col-lg-5  ml-5">
                        <label>Future Role</label><br />
                        <input
                            type="text"
                            className='form-control'

                        ></input>
                    </div>

                    <div class="col-lg-5 mt-3">
                        <label>Training</label><br />
                        <input
                            type="number"
                            className='form-control'

                        ></input>
                    </div>

                    <div className="col-lg-5 mt-3 ml-5">
                        <label>Justification</label>
                        <textarea
                            className={`form-control h-75`}
                            placeholder="LoremIpsum is simply dummmy text"
                            name="description"

                        ></textarea>

                    </div>
                </div>

                <div className="col-lg-5 mt-5 ml-n2">
                    <label>Is there any course needs to be taken Outside?</label>
                    <textarea
                        className={`form-control h-100 `}
                        placeholder="LoremIpsum is simply dummmy text"
                        name="description"

                    ></textarea>

                </div>

            </div>





            <div className="col-lg-11 text-end mt-5 pb-3">

                {/* <!-- Button trigger modal --> */}
                <button type="button" className="border-0 mt-3 p-1 savebtn fst-normal" data-bs-toggle="modal" data-bs-target="#exampleModal">
                    Save
                </button>

                {/* <!-- Modal --> */}
                <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="text-dark fw-bold h5" id="exampleModalLabel">CONFIRM CHANGES</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                ...
                            </div>
                            <div class="modal-footer">

                                <button type="button" class="btn btn-primary subcatbtn">Save changes</button>
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>

                <a href="/Skills" className="text-decoration-none "> <Button
                    type="button"
                    className="btn cancelbtn ml-2"

                >
                    Cancel
                </Button></a>
            </div>

        </div>












    );
}
export default MyPlanForm;


